import React from 'react';
import { ReactComponent as InstagramIcon } from '../../assets/images/svg/instagram.svg';
import { ReactComponent as InstagramHoverIcon } from '../../assets/images/svg/instagram-hover.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/images/svg/youtube.svg';
import { ReactComponent as YoutubeHoverIcon } from '../../assets/images/svg/youtube-hover.svg';
import { ReactComponent as FacebookIcon } from '../../assets/images/svg/fb.svg';
import { ReactComponent as FacebookHoverIcon } from '../../assets/images/svg/fb-hover.svg';
import { ReactComponent as TiktokIcon } from '../../assets/images/svg/titktok.svg';
import { ReactComponent as TiktokHoverIcon } from '../../assets/images/svg/tiktok-hover.svg';
import './SocialNetworks.css';

export default function SocialNetworks() {
  return (
    <ul className="social-networks">
      <li className="tiktok">
        <a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@good_deeds_day?lang=en" tabIndex="0" aria-label="TikTok">
          <TiktokIcon className="social-icon social-icon-default" />
          <TiktokHoverIcon className="social-icon social-icon-hover" />
        </a>
      </li>
      <li className="facebook">
        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/GoodDeedsDay" tabIndex="0" aria-label="Facebook">
          <FacebookIcon className="social-icon social-icon-default" />
          <FacebookHoverIcon className="social-icon social-icon-hover" />
        </a>
      </li>
      <li className="youtube">
        <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/user/RuachTova" tabIndex="0" aria-label="Youtube">
          <YoutubeIcon className="social-icon social-icon-default" />
          <YoutubeHoverIcon className="social-icon social-icon-hover" />
        </a>
      </li>
      <li className="instagram">
        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/gooddeedsdayisrael/" tabIndex="0" aria-label="Instagram">
          <InstagramIcon className="social-icon social-icon-default" />
          <InstagramHoverIcon className="social-icon social-icon-hover" />
        </a>
      </li>
    </ul>
  );
}
